import React, { createContext, useContext, useEffect, ReactNode } from 'react';
import { Bet, BetContextState,WidgetConfig, SelectionsData,BetState,Cultures,CalaculationRequest, TotalOdd } from '../types';
import { buildCalculationRequest,removedItems} from '../utils/utils'
import getConfig from '../config';
import {calculateOdds} from '../api/api';
import { useWidgetContext } from './WidgetContext';
import {BET_BUILDER_ACCEPT_ODDS_CHANGES,
        BET_BUILDER_ADD_BETS,
        BET_BUILDER_CLEAR_ALL,
        BET_BUILDER_DISABLE,
        BET_BUILDER_RECALCULATE,
        BET_BUILDER_REMOVE_BETS,
        ADD_BETS,UPDATE_CONFIG,
        ACCEPT_ODDS_CHANGES,CHANGE_CULTURE,
        CLEAR_ALL,DISABLE,ODDS_CHANGED,RECALCULATE,REMOVE_BETS,REMOVE_EVENT_BETS,SET_TOTAL_ODDS,REMOVE_EVENT,
        BET_BUILDER_REMOVE_EVENT,SHOW_ON_SUCCESS,REMOVE_ON_ERROR,BET_BUILDER_UPDATE_CONFIG} from '../utils/consts';

const BetContext = createContext<BetContextState | undefined>(undefined);

export interface BetProviderProps {
  children: ReactNode;
  onBetRemove?: (bets: Bet[]) => void;
  onClearAll?: () => void;
  onStateChanged?: (state: BetState) => void;
  onBetAdded?:(bets: Bet[]) => void;
  onError?:(e:any,message:string)=>void;
  onCultureChanged?:(culture:Cultures)=>void;
  onCultureDisable?:(disable:boolean)=>void
  onRecalculate?:()=>void
  onEventRemove?:(eventId:string)=>void
  onEventSelected?:(eventId:string)=>void
  
}

export const BetProvider: React.FC<BetProviderProps> = ({ 
  children,
  onBetRemove,
  onEventRemove,
  onClearAll,
  onBetAdded,
  onError,
  onEventSelected   
}) => {
  const { bets, totalOdds, dispatch,config} = useWidgetContext();
  const envConfig = getConfig(config.environment);
  const calculationApiUrl = config.calculationApiUrl || envConfig.calculationApiUrl;
 
  useEffect(() => {
    if (bets.length > 0) {
      const dirtyBets = bets.filter(b=>b.isDirty==true);
      let request:CalaculationRequest = buildCalculationRequest(bets);
      if(dirtyBets.length>0){
        calculateOdds(config.brandId || '', request, calculationApiUrl).then(odds => {
          dispatch({ type: SHOW_ON_SUCCESS, payload: dirtyBets });
          dispatch({ type: SET_TOTAL_ODDS, payload: odds });
        }).catch((e:any)=>{
          const removed = removedItems(bets, dirtyBets)
          if(config.ignoreCalculationError){
            dispatch({ type: SHOW_ON_SUCCESS, payload: dirtyBets });
            let mockOdds:TotalOdd[] = [];
            request.BetBuilderEvents.forEach(c=>{
              mockOdds.push({
                eventId:c.EventId,
                previouseOdd:Math.floor(Math.random() * (10 - 2 + 1)) + 2,
                odd:Math.floor(Math.random() * (10 - 2 + 1)) + 2

              })
            })
            dispatch({ type: SET_TOTAL_ODDS, payload: mockOdds });
            
          }else{
            dispatch({ type: REMOVE_ON_ERROR, payload:removed });
          }
          
          if (onBetRemove) onBetRemove(removed);
          if (onError) onError(e, e.message); 
        });
      }
      
    }
  }, [bets, calculationApiUrl,config]);

  
  useEffect(() => {
    
    const handleAddBet = (e: Event) => {
      if (!config.viewOnly) {
        const customEvent = e as CustomEvent<Bet[]>;
        dispatch({ type: ADD_BETS, payload: customEvent.detail });
        if (onBetAdded) onBetAdded(customEvent.detail);
      }
    };

    const handleRemoveBet = (e: Event) => {
      if (!config.viewOnly) {
        const customEvent = e as CustomEvent<Bet[]>;
        const oldBets = bets;
        const onChnageList = removedItems(oldBets,customEvent.detail);
        dispatch({ type: REMOVE_BETS, payload: customEvent.detail });
        if (onBetRemove) onBetRemove(onChnageList);
        if (onEventRemove && onChnageList.length>customEvent.detail.length) onEventRemove(onChnageList[0].eventId);
      }
      
    };
    const handleRemoveEvent = (e: Event) => {
      
      const customEvent = e as CustomEvent<string>;
      dispatch({ type: REMOVE_EVENT, payload: customEvent.detail });
      if (onEventRemove) onEventRemove(customEvent.detail);
      
      
    };

    const handleClearAll = () => {
      
      dispatch({ type: CLEAR_ALL });
      
      if (onClearAll) onClearAll();
    };

    const handleRecalculate = (e: Event) => {
      
      const customEvent = e as CustomEvent<Bet[]>;
      dispatch({ type: RECALCULATE, payload: customEvent.detail });
       
    }; 
    
    const handleDisable = (e: Event) => {
      const customEvent = e as CustomEvent<boolean>;
      dispatch({ type: DISABLE, payload: customEvent.detail });
      
    };

    const handleUpdateCofig = (e: Event) => {
      const customEvent = e as CustomEvent<WidgetConfig>;
      dispatch({ type: UPDATE_CONFIG, payload: customEvent.detail });
      
    };
    const handleAcceptOddsChanges = (e: Event) => {
      const customEvent = e as CustomEvent<boolean>;
      dispatch({ type: ACCEPT_ODDS_CHANGES, payload: customEvent.detail });
      
    };
    document.addEventListener(BET_BUILDER_ADD_BETS, handleAddBet);
    document.addEventListener(BET_BUILDER_REMOVE_BETS, handleRemoveBet);
    document.addEventListener(BET_BUILDER_CLEAR_ALL, handleClearAll);
    document.addEventListener(BET_BUILDER_DISABLE, handleDisable);
    document.addEventListener(BET_BUILDER_RECALCULATE, handleRecalculate);
    document.addEventListener(BET_BUILDER_ACCEPT_ODDS_CHANGES, handleAcceptOddsChanges);
    document.addEventListener(BET_BUILDER_REMOVE_EVENT, handleRemoveEvent);
    document.addEventListener(BET_BUILDER_UPDATE_CONFIG, handleUpdateCofig);
    return () => {
      document.removeEventListener(BET_BUILDER_ADD_BETS, handleAddBet);
      document.removeEventListener(BET_BUILDER_REMOVE_BETS, handleRemoveBet);
      document.removeEventListener(BET_BUILDER_CLEAR_ALL, handleClearAll);
      document.removeEventListener(BET_BUILDER_DISABLE, handleDisable);
      document.removeEventListener(BET_BUILDER_RECALCULATE, handleRecalculate);
      document.removeEventListener(BET_BUILDER_ACCEPT_ODDS_CHANGES, handleAcceptOddsChanges);
      document.removeEventListener(BET_BUILDER_REMOVE_EVENT, handleRemoveEvent);
      document.removeEventListener(BET_BUILDER_UPDATE_CONFIG, handleUpdateCofig);
    };
  }, [config.viewOnly, bets]);

  const addBets = (bets: Bet[]) => {
    if (!config.viewOnly) {
      dispatch({ type: ADD_BETS, payload: bets });
    }
  };

  const removeBets = (removed: Bet[]) => {
    if (!config.viewOnly) {
      const oldBets = bets;
      const onChnageList = removedItems(oldBets,removed);
      dispatch({ type: REMOVE_BETS, payload: removed });
      if (onBetRemove) onBetRemove(onChnageList);
      if (onEventRemove && onChnageList.length>removed.length) onEventRemove(onChnageList[0].eventId);
    }
  };

  const recalculate = (bets: Bet[]): SelectionsData => {
    dispatch({ type: RECALCULATE, payload: bets });
    return {
      selections:bets,
      totalOdds:[]
    }     
  };
    
  const oddsChanged = (bet: Bet) => {
    dispatch({ type: ODDS_CHANGED, payload: bet});
      
  };

  const removeEventBets = (eventId: string) => {
    if (!config.viewOnly || config.allowRemoveEvent) {
      dispatch({ type: REMOVE_EVENT_BETS, payload: eventId });
      if (onEventRemove) onEventRemove(eventId);
    }

  };

  const clearAll = () => {
    if (!config.viewOnly) {
      dispatch({ type: CLEAR_ALL });
      if (onClearAll) onClearAll();
    }
  };
  const eventSelected = (eventId: string) => {
    if (!config.viewOnly) {
      
      if (onEventSelected) onEventSelected(eventId);
    }
  };

  const changeCulture = (culture:Cultures) => {
    dispatch({ type: CHANGE_CULTURE, payload: culture});
      
  };

  return (
    <BetContext.Provider value={{
      bets: bets,
      totalOdds: totalOdds,
      addBets,
      removeBets,
      removeEventBets,
      clearAll,
      recalculate,
      changeCulture,
      oddsChanged,
      eventSelected,
      config: config
    }}>
      {children}
    </BetContext.Provider>
  );
};

export const useBetContext = (): BetContextState => {
  const context = useContext(BetContext);
  if (!context) {
    throw new Error('useBetContext must be used within a BetProvider');
  }
  return context;
};

// Export the context
export default BetContext;